/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { type Organisation } from '../../../types';
import { useIsSwitcherTeam25TestCohort } from '../experiment-provider';

interface CurrentUserProps extends Organisation {
	email: string;
}

const currentUserStyles = cssMap({
	root: {
		marginTop: token('space.025'),
	},
});

const CurrentUser = ({ email }: CurrentUserProps) => {
	const isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();

	return (
		<Box xcss={currentUserStyles.root}>
			<Text
				as="p"
				color={isVisualRefreshEnabled ? 'color.text.subtlest' : 'color.text.subtle'}
				weight="regular"
				size="small"
			>
				{email}
			</Text>
		</Box>
	);
};
export default CurrentUser;
